'use strict';

var _ = require('lodash');
var FlightClassMixChartController = function FlightClassMixChartController(scope, dataRetrieverService, dataRetrieverConstantsService, analysisMetricService, dataProviderService, formatterService, visibilityManager, $filter) {
  var defaultMetric = 'bookings';
  var rmNumberFormat = $filter('rmNumberFormat');
  var mode = dataRetrieverConstantsService.FLIGHT_CLASS_PROFILE_MODE;
  var analysisMetric = analysisMetricService.getAnalysisMetric(scope.screen);
  var tooltipFlightTemplate = _.template(require('../templates/tooltip-template.html'));
  scope.metrics = analysisMetric.getMetricValues(mode, defaultMetric);
  scope.metricLabels = analysisMetric.getAvailableLabels(mode);
  scope.selectedMetric = _.find(scope.metricLabels, {
    id: defaultMetric
  });
  scope.chartFormatters = {
    yAxisTickFormatter: formatterService.humanReadable,
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = {
        className: d.className,
        m1: rmNumberFormat(d.m1, 'NUMBER'),
        m4: d.m4 !== undefined ? rmNumberFormat(d.m4, 'NUMBER') : undefined
      };
      if (!scope.postDepartureMode) {
        tooltipModel.m3 = d.m3 !== undefined ? rmNumberFormat(d.m3, 'NUMBER') : undefined;
      }
      scope.metrics.forEach(function (metric) {
        tooltipModel[metric.mappedKey + 'Label'] = metric.label.replace('{DTD}', scope.dtd);
      });
      return tooltipFlightTemplate(tooltipModel);
    }
  };
  scope.chartFormatters.tooltipFormatter.cssClass = 'flight-class-mix-chart-tooltip';
  var legendMapping = {
    legend: [{
      fill: '#376092',
      label: 'RTP 000',
      id: 'rtp'
    }, {
      label: 'LY',
      fill: 'white',
      stroke: '#707070',
      style: 'circle',
      id: 'ly'
    }, {
      label: 'Final LY',
      fill: 'black',
      style: 'circle',
      id: 'final-ly'
    }],
    postDepartureLegend: [{
      fill: '#376092',
      label: 'RTP 000',
      id: 'rtp'
    }, {
      label: 'Final LY',
      fill: 'black',
      style: 'circle',
      id: 'final-ly'
    }]
  };
  scope.closeClassMixGraph = function () {
    scope.$emit('class-mix-graph:close');
  };
  scope.updateLegend = function (readingTimePoint) {
    if (scope.postDepartureMode) {
      scope.legend = legendMapping.postDepartureLegend;
    } else {
      scope.legend = legendMapping.legend;
    }
    scope.legend[0].label = 'RTP ' + readingTimePoint;
  };
  scope.updateChart = function (metric) {
    if (visibilityManager.isClassMixChartVisible()) {
      dataProviderService.getData(dataRetrieverConstantsService.FLIGHT_SCREEN, 'flight-class-profile-mode', 'flight-class-mix-graph', metric, scope.postDepartureMode).then(scope.renderChart);
    }
  };
  scope.onBrushFilter = function (event, brushFilter) {
    if (brushFilter.filterType === 'profileChart' && brushFilter.filterArguments[0].length > 0) {
      var filter = brushFilter.filterArguments[0][0];
      scope.filterMetric = filter.metric;
      scope.metrics = analysisMetric.getMetricValues(mode, filter.metric);
      scope.metricLabels = analysisMetric.getAvailableLabels(mode);
      scope.selectedMetric = _.find(scope.metricLabels, {
        id: filter.metric
      });
      scope.dtd = filter.daysToDeparture;
      scope.updateLegend(filter.daysToDeparture);
      scope.updateChart(filter.metric);
    }
  };
};
FlightClassMixChartController.$inject = ['$scope', 'DataRetrieverService', 'DataRetrieverConstantsService', 'AnalysisMetricService', 'FlightClassMixChartDataProviderService', 'FormatterService', 'FlightComponentVisibilityManagerService', '$filter'];
module.exports = FlightClassMixChartController;